import * as React from "react";

import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";

import IconButton from "@mui/material/IconButton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Typography from "@mui/material/Typography";

import FavoriteIcon from "@mui/icons-material/Favorite";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { projectsUtils } from "./../../utils/projectsUtils";
import Grid from "@mui/material/Grid";
import Badge from "react-bootstrap/Badge";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

let Project = () => {
  const [expandedId, setExpandedId] = React.useState(-1);

  const [favorites, setFavorites] = React.useState({});

  const handleFavoriteClick = (id) => {
    setFavorites((prevFavorites) => ({
      ...prevFavorites,
      [id]: !prevFavorites[id],
    }));
  };

  const handleExpandClick = (id) => {
    console.log("id", id);
    setExpandedId((prevExpandedId) => (prevExpandedId === id ? -1 : id));
  };

  return (
    <Grid container spacing={5} sx={{ xs: { justifyContent: "center" } }}>
      {projectsUtils.map((item) => (
        <Grid
          item
          key={item.id}
          xs={12}
          sm={6}
          md={4}
          sx={{ xs: { marginLeft: "50px" } }}
        >
          <Card
            sx={{
              maxWidth: 345,
              maxWidth: {
                xs: 600, // Adjusted for mobile devices
              },
            }}
          >
            <CardHeader
              title={
                <React.Fragment>
                  <Badge
                    bg={item.color}
                    style={{
                      padding: "0.5em",
                      backgroundColor: item.color,
                      fontSize: "13px",
                    }}
                  >
                    {item.batch}
                  </Badge>
                  <Typography variant="subtitle1" sx={{ fontSize: "0.875rem" }}>
                    {item.title}
                  </Typography>
                </React.Fragment>
              }
            />
            <CardMedia
              component="img"
              height="194"
              image={item.image}
              alt="Project Image"
            />
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                {item.description.substring(0, 60)}...
              </Typography>
            </CardContent>
            <CardActions disableSpacing>
              <IconButton
                aria-label="add to favorites"
                onClick={() => handleFavoriteClick(item.id)}
                color={favorites[item.id] ? "secondary" : "default"}
              >
                <FavoriteIcon
                  color={favorites[item.id] ? "error" : "inherit"}
                  fontSize="small"
                />
              </IconButton>
              <IconButton
                aria-label="share"
                sx={{ "&:hover": { color: "#9100C3" } }}
              >
                <a
                  href={item.link}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {" "}
                  <RemoveRedEyeIcon />
                </a>
              </IconButton>
              <ExpandMore
                expand={expandedId === item.id}
                onClick={() => handleExpandClick(item.id)}
                aria-expanded={expandedId === item.id}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </ExpandMore>
            </CardActions>
            <Collapse in={expandedId === item.id} timeout="auto" unmountOnExit>
              <CardContent>
                <Typography paragraph>Description</Typography>
                <Typography paragraph>{item.description}</Typography>
              </CardContent>
            </Collapse>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default Project;
